import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import ModalSheet from 'components/common/ModalSheet';
import Link from '../../../components/common/Link';

export const ModalSheetContainer = styled.div`
  padding: 0 24px;

  @media (min-width: ${DEVICE.mobileXL}) {
    padding: 0;
  }
  color: ${props =>
    props.theme.hasTemplate
      ? props.theme.colors.branding.fontPrimary
      : props.theme.colors.$p10};
  display: block;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: left;
`;

export const PrivacyPolicyLink = styled(Link)`
  text-decoration: revert;
`;

export const Modal = styled(ModalSheet)`
  max-width: 600px;
`;
